import React, { useEffect, useRef } from "react";

const decodeHTMLEntities = (encodedStr) => {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = encodedStr;
    return textArea.value;
};

const ChatSystem = ({ data }) => {
    const chatEndRef = useRef(null);

    useEffect(() => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [data]);

    const safeData = Array.isArray(data) ? data : [];

    return (
        <div className="relative w-full h-full overflow-hidden flex flex-col">
            <div className="flex-1 overflow-y-auto overflow-x-hidden px-4 space-y-4 max-w-6xl mx-auto"> {/* Changed to max-w-6xl for wider tables */}
                {safeData.length > 0 ? (
                    safeData.map((message, index) => {
                        let botContent = {};
                        try {
                            botContent = JSON.parse(message.bot);
                        } catch {
                            botContent = { response: message.bot };
                        }
                        return (
                            <div key={index} className="space-y-2">
                                {message.user && (
                                    <div className="flex justify-end">
                                        <div className="bg-blue-500 text-white text-sm rounded-lg px-4 py-2 max-w-xl break-words shadow-md"> {/* Changed to max-w-xl */}
                                            {message.user.length > 200
                                                ? message.user.slice(0, 200) + "..."
                                                : message.user}
                                        </div>
                                    </div>
                                )}
                                {message.bot && (
                                    <div className="flex justify-start">
                                        <div className="bg-gray-100 text-gray-800 text-sm rounded-lg px-4 py-2 max-w-xl break-words shadow-md"> {/* Changed to max-w-xl */}
                                            <div
                                                className="prose prose-sm whitespace-pre-wrap max-w-full [overflow-x-auto] [&_table]:table [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_th]:border [&_td]:p-2 [&_th]:p-2 [&_table]:border-gray-300"
                                                dangerouslySetInnerHTML={{
                                                    __html: decodeHTMLEntities(botContent.response),
                                                }}
                                            />
                                            {botContent.reason && (
                                                <div className="mt-2 text-xs text-gray-500 italic">
                                                    <strong>Reason:</strong> {botContent.reason}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center text-gray-400">No messages available.</div>
                )}
                <div ref={chatEndRef} />
            </div>
        </div>
    );
};

export default React.memo(ChatSystem); // Memoize to optimize re-renders